export const PRIVACY_POLICY_CONTENT = {
  title: 'ПОЛИТИКА КОНФИДЕНЦИАЛЬНОСТИ',
  updatedAt: 'Последнее обновление: 01.11.2026',
  blocks: [
    {
      type: 'paragraph',
      text: 'Настоящая Политика конфиденциальности (далее – Политика) является неотъемлемой частью Пользовательского соглашения (далее – Соглашение), размещённого на сайте https://strategikon.cloud, и регулирует порядок сбора, обработки, хранения и защиты персональных данных Пользователей.'
    },
    {
      type: 'paragraph',
      text: 'Используя Сайт и/или проходя регистрацию в Игре, Пользователь даёт своё полное и безоговорочное согласие с условиями настоящей Политики.'
    },
    {
      type: 'paragraph',
      text: 'Администрация Игры обеспечивает защиту персональных данных в соответствии с действующим законодательством Российской Федерации.'
    },
    {type: 'heading', text: '1. Термины и определения'},
    {
      type: 'paragraph',
      text: '1.1. Персональные данные – любая информация, относящаяся к прямо или косвенно определённому или определяемому физическому лицу (субъекту персональных данных).'
    },
    {
      type: 'paragraph',
      text: '1.2. Обработка персональных данных – любое действие (операция) или совокупность действий, совершаемых с использованием средств автоматизации или без их использования с персональными данными.'
    },
    {
      type: 'paragraph',
      text: '1.3. Игра – браузерная  игра, расположенная по адресу https://strategikon.cloud, право собственности или право использования которой на законных основания принадлежит ИП Баценков Я.С., являющаяся программой для ЭВМ и представляющая собой совокупность данных, команд и порождаемых ею аудиовизуальных отображений (далее ‑ «Данные» и Команды»), активируемых последовательно для получения Пользователем определенного результата, предусмотренного сценарием Игры, без внесения платы (активированные Данные и Команды) или после внесения лицензионного платежа (неактивированные Данные и Команды).'
    },
    {
      type: 'paragraph',
      text: 'Право использования Игры предоставляются Пользователю ИП Баценковым Я.С. на условиях, определенных настоящим Соглашением.'
    },
    {
      type: 'paragraph',
      text: 'Игра также включает в себя (помимо прочего): серверы, серверное и иное программное обеспечение, Сайт Игры, Премиум магазин, базы данных и другие ресурсы, необходимые для использования Игры в рамках настоящего Соглашения.'
    },
    {
      type: 'paragraph',
      text: '1.4. Сайт Игры – интернет-сайт https://strategikon.cloud, предоставляющий доступ к Игре.'
    },
    {type: 'paragraph', text: '1.5. Администрация — владелец Сайта и лица, уполномоченные управлять Игрой.'},
    {
      type: 'paragraph',
      text: '1.6. Пользователь — дееспособное физическое лицо, достигшее 18 лет, использующее Сайт Игры.'
    },
    {
      type: 'paragraph',
      text: '1.7. Учетная запись (Аккаунт) – уникальная запись Пользователя, создаваемая для доступа к Игре.'
    },
    {
      type: 'paragraph',
      text: '1.8. Дееспособность. Пользователь настоящим подтверждает, что обладает дееспособностью, достаточной для заключения настоящего Соглашения. Если Пользователь не достиг совершеннолетия (18 лет) или является полностью либо частично недееспособным согласно законодательству РФ, Пользователь подтверждает, что получил разрешение родителей или иных законных представителей на заключение настоящего Пользовательского Соглашения в установленной законодательством форме.'
    },
    {
      type: 'paragraph',
      text: '1.9. Права на неактивированные Данные и Команды – предусмотренные настоящим Соглашением права на использование данных, команд (в частности, внутри игровой валюты, премиум-аккаунта, других данных, команд) и порождаемых ими аудиовизуальных отображений Игры, активируемых последовательно для получения Пользователем определенного результата, предусмотренного сценарием Игры, приобретаемые Пользователем после внесения установленного лицензионного платежа.'
    },
    {
      type: 'paragraph',
      text: '1.10. Премиум магазин – ресурс Игры, посредством которого Пользователь может приобрести Права на неактивированные Данные и Команды.'
    },
    {
      type: 'paragraph',
      text: '1.11. Виртуальная валюта — виртуальная внутри игровая единица, которая не имеет денежной стоимости и не подлежит денежной оценке, хотя и имеет цену на момент приобретения. Не является средством платежа.'
    },
    {
      type: 'paragraph',
      text: '1.12.  Оператор — лицо, самостоятельно или совместно с другими лицами организующее и/или осуществляющее обработку персональных данных, а также определяющее цели обработки персональных данных, состав персональных данных, подлежащих обработке, действия (операции), совершаемые с персональными данными. Для целей настоящей Политики Администрация, обрабатывая персональные данные, является Оператором, если иное прямо не указано в Политике.'
    },
    {type: 'heading', text: '2. Общие положения'},
    {
      type: 'paragraph',
      text: '2.1.  При регистрации, каждом доступе и/или фактическом использовании Игры  Пользователь подтверждает свое ознакомление и согласие с условиями обработки его персональных данных, указанными в Политике в той редакции, которая действует на момент фактического использования Игры. Перед тем как начать использование Игры Пользователь обязан ознакомиться с настоящей Политикой.'
    },
    {
      type: 'paragraph',
      text: '2.2.  Администрация вправе в одностороннем порядке в любой момент вносить изменения в Политику, в том числе в связи с внесением изменений в применимое законодательство или изменений в работе Игры. Новая редакция Политики вступает в силу с момента ее размещения по адресу: https://strategikon.cloud/privacypolicy, если иное не предусмотрено новой редакцией Политики.'
    },
    {
      type: 'paragraph',
      text: 'Администрация уведомляет Пользователя об изменении Политики путем размещения ее новой редакции по вышеуказанному в настоящем пункте адресу. Продолжая использовать Игру после внесения изменений в Политику, Пользователь подтверждает свое согласие с такими изменениями.'
    },
    {
      type: 'paragraph',
      text: 'Администрация рекомендует регулярно проверять содержание настоящей Политики на предмет ее возможных изменений.'
    },
    {
      type: 'paragraph',
      text: '2.3.  Документами, регулирующими обработку персональных данных Пользователей, являются:'
    },
    {type: 'listItem', text: 'настоящая Политика;'},
    {
      type: 'listItem',
      text: 'Федеральный закон от 27.07.2006 № 152-ФЗ «О персональных данных» (далее – «Закон «О персональных данных»);'
    },
    {
      type: 'listItem',
      text: 'Федеральный закон от 27.07.2006 № 149-ФЗ «Об информации, информационных технологиях и о защите информации»;'
    },
    {
      type: 'listItem',
      text: 'иные нормативные правовые акты, применимые к обработке персональных данных Администрацией.'
    },
    {
      type: 'paragraph',
      text: '2.4. Администрация не проверяет персональные данные, предоставленные Пользователем при использовании им Игры. В связи с этим Администрация не может установить, достоверны ли такие персональные данные, а также обладает ли Пользователь достаточной правоспособностью для предоставления персональных данных. Тем не менее, Администрация исходит из того, что Пользователь предоставляет достоверные и достаточные персональные данные, а также своевременно обновляет их. Создавая учетную запись в рамках Игры, либо получая доступ к Игре без регистрации, Пользователь подтверждает, что достиг допустимого возраста использования Игры (18 лет), установленного в данной Политике.'
    },
    {
      type: 'paragraph',
      text: '2.5. Администрация не осуществляет обработку биометрических персональных данных Пользователя. Администрация также не осуществляет обработку специальных категорий персональных данных Пользователя, касающихся расовой, национальной принадлежности, политических взглядов, религиозных или философских убеждений, состояния здоровья, интимной жизни.'
    },
    {
      type: 'paragraph',
      text: '2.6.  Если функционал используемый Игры предусматривает отображение информации о Пользователе в его учетной записи, доступной для просмотра другим пользователям Игры или пользователям сети Интернет, то Пользователь соглашается на отражение информации о нем в своей учетной записи. Пользователь также соглашается, что иные данные о Пользователе, помимо вышеуказанных в настоящем пункте данных, могут быть доступны другим пользователям Игры или пользователям сети Интернет с учетом предусмотренного функционала Игры.'
    },
    {
      type: 'paragraph',
      text: '2.7 К персональным данным Пользователя относятся ФИО, дата и место рождения, пол, номер телефона, email, IP-адрес, платёжные данные, игровая статистика, а также иная информация, предусмотренная 152-ФЗ «О персональных данных».'
    },
    {type: 'heading', text: '3. Цели обработки персональных данных'},
    {type: 'paragraph', text: 'Администрация обрабатывает персональные данные для следующих целей:'},
    {
      type: 'paragraph',
      text: '3.1. Предоставление Пользователю доступа к Игре и её функциям (регистрация, авторизация, игровой процесс).'
    },
    {
      type: 'paragraph',
      text: '3.2. Исполнение обязательств по Пользовательскому соглашению: учёт оплат, начисление виртуальной валюты, предоставление премиум-аккаунта, обработка транзакций.'
    },
    {
      type: 'paragraph',
      text: '3.3. Улучшение качества Сервиса: анализ пользовательского поведения, сбор статистики, оптимизация игровых механик, проведение маркетинговых исследований.'
    },
    {
      type: 'paragraph',
      text: '3.4. Информирование Пользователя о новостях, акциях, обновлениях Игры (при наличии отдельного согласия на рассылку).'
    },
    {
      type: 'paragraph',
      text: '3.5. Предотвращение мошенничества, злоупотреблений, читерства и других нарушений правил Игры.'
    },
    {type: 'paragraph', text: '3.6. Обеспечение безопасности и защиты прав Администрации и третьих лиц.'},
    {type: 'heading', text: '4. Предоставление персональных данных третьим лицам'},
    {
      type: 'paragraph',
      text: 'Администрация может предоставлять персональные данные Пользователей третьим лицам, принимая во внимание цели обработки персональных данных. К таким третьим лицам, в частности, относятся лица, перечисленные ниже в настоящем пункте:'
    },
    {type: 'paragraph', text: '4.1. Провайдеры платежных услуг'},
    {
      type: 'paragraph',
      text: 'Администрация сотрудничает с провайдерами платежных услуг для обработки платежей Пользователя при покупке им прав на Неактивированные элементы Игры, в связи с чем передает им необходимые для исполнения Политики данные Пользователя (куда, в зависимости от конкретной платформы, могут включаться: адрес электронной почты, онлайн-идентификаторы Пользователя, техническая информация, необходимая для нормальной работы Игры, и т.д.).'
    },
    {type: 'paragraph', text: '4.2. Другие пользователи Игры'},
    {
      type: 'paragraph',
      text: 'Другие пользователи могут видеть некоторые из данных учетной записи Пользователя, если это допускается соответствующими настройками и функциональностью Игры.'
    },
    {type: 'paragraph', text: '4.3. Партнеры, обеспечивающие хранение данных'},
    {
      type: 'paragraph',
      text: 'Администрация хранит часть информации с использованием услуг третьих лиц по хранению данных. При этом в рамках сбора персональных данных, в том числе, в сети Интернет, Администрация обеспечивает запись, систематизацию, накопление, хранение, уточнение (обновление, изменение), извлечение персональных данных граждан Российской Федерации с использованием баз данных, находящихся на территории Российской Федерации. Кроме того, Администрация может хранить определенные персональные данные Пользователя на серверах с использованием облачных хранилищ.'
    },
    {type: 'paragraph', text: '4.4. Партнеры, обеспечивающие направление новостных рассылок и рекламных сообщений'},
    {
      type: 'paragraph',
      text: 'Для достижения цели обработки - продвижение Игры, реклама, персональные данные могут передаваться, а также к их обработке могут привлекаться (как с условием поручения, так и без такового): лица, которые предоставляют сервисы для направления новостных рассылок и рекламных сообщений по электронной почте.'
    },
    {type: 'paragraph', text: '4.5. Сервисы статистики и рекламные счетчики'},
    {
      type: 'paragraph',
      text: 'Для достижения цели обработки — оценка эффективности рекламы и улучшение Игры — на Сайте установлены счётчики сторонних сервисов (Яндекс Метрика, пиксель VK Рекламы). Им передаются сведения о посещениях и действиях на Сайте, технические данные устройства и браузера, а также внутренний игровой идентификатор Пользователя. Адрес электронной почты, платёжные данные и иные сведения, позволяющие напрямую установить личность Пользователя, этим сервисам не передаются. Подробнее — в разделе 9 настоящей Политики.'
    },
    {type: 'paragraph', text: '4.6. Государственные органы и аудиторы'},
    {
      type: 'paragraph',
      text: 'Администрация может предоставить персональные данные Пользователя третьим лицам в случаях, предусмотренных законом, например, на основании обращений (запросов и т.д.) органов государственной власти, местного самоуправления и/или правоохранительных органов, требований аудиторов и иных уполномоченных лиц, действующих в соответствии с применимым законодательством. В каждом случае Компания тщательно оценивает обстоятельства и передает данные в наименьшем возможном объеме.'
    },
    {type: 'heading', text: '5. Сроки и условия хранения данных'},
    {
      type: 'paragraph',
      text: '5.1. Персональные данные хранятся в течение срока, необходимого для целей обработки, но не более 5 лет с момента последней активности Пользователя» (для налогового учёта)'
    },
    {type: 'paragraph', text: '5.2. По истечении срока хранения данные уничтожаются либо обезличиваются.'},
    {type: 'heading', text: '6. Права Пользователя'},
    {type: 'paragraph', text: 'В соответствии с ФЗ-152 Пользователь имеет право:'},
    {type: 'paragraph', text: '6.1. На доступ к своим персональным данным и получение информации о их обработке.'},
    {
      type: 'paragraph',
      text: '6.2. На уточнение, блокирование или уничтожение своих персональных данных, если они являются неполными, устаревшими, недостоверными или обрабатываются незаконно.'
    },
    {
      type: 'paragraph',
      text: '6.3. На отзыв согласия на обработку персональных данных (при этом Администрация вправе продолжать обработку, если есть законные основания, например, исполнение договора).'
    },
    {
      type: 'paragraph',
      text: 'При отзыве согласия на маркетинг, обработка для исполнения договора (например, обслуживание аккаунта) продолжится.'
    },
    {
      type: 'paragraph',
      text: '6.4. На удаление своей Учетной записи – для этого Пользователь может направить запрос в службу поддержки. При удалении все игровые данные и виртуальные предметы будут утеряны.'
    },
    {
      type: 'paragraph',
      text: '6.5. Для реализации своих прав Пользователь может направить письменный запрос по адресу электронной почты. Ответ будет дан в течение 10 календарных дней.'
    },
    {type: 'heading', text: '7. Интеллектуальная собственность'},
    {
      type: 'paragraph',
      text: '7.1. Все элементы Игры, включая, но не ограничиваясь: код, дизайн, изображения, иконки, музыка, звуковые эффекты, названия, являются объектами интеллектуальной собственности Администрации и защищены законодательством РФ.'
    },
    {
      type: 'paragraph',
      text: '7.2. В Игре используются изображения, иконки, карточки и другой визуальный контент, сгенерированный технологиями искусственного интеллекта (ИИ).'
    },
    {type: 'paragraph', text: 'Используемые  инструменты ИИ:'},
    {type: 'paragraph', text: '1. Google Gemini.'},
    {type: 'paragraph', text: '2. Шедеврум (YandexART).'},
    {
      type: 'paragraph',
      text: 'Все изображения, созданные с помощью ИИ и используемые в Игре, были получены на законных основаниях. Мы не заявляем, что изображения созданы исключительно человеком без участия ИИ.'
    },
    {
      type: 'paragraph',
      text: 'В Игре используются звуковые эффекты и музыкальные элементы (далее – Звуки) из библиотеки Splice Sounds.'
    },
    {
      type: 'paragraph',
      text: 'Мы используем Звуки из Splice в строгом соответствии с условиями использования платформы. В случае необходимости мы можем предоставить сертифицированную лицензию (Certified License) для подтверждения легальности использования каждого звука.'
    },
    {
      type: 'paragraph',
      text: 'В Игре также используются звуковые эффекты из библиотеки Uppbeat (uppbeat.io). Права на эти звуки принадлежат их авторам и правообладателям. С вопросами о них можно написать на strategikon.game@yandex.ru.'
    },
    {type: 'paragraph', text: 'В оформлении Игры используются иконки с сервиса Flaticon (www.flaticon.com).'},
    {
      type: 'paragraph',
      text: 'Все иконки используются на условиях бесплатной лицензии Flaticon с обязательной атрибуцией автора. Более подробно можете ознакомиться  на сайте в разделе «Благодарности».'
    },
    {
      type: 'paragraph',
      text: '7.3. Приобретая Права на неактивированные Данные и Команды, Пользователь получает ограниченную, личную, непередаваемую лицензию на их использование исключительно в рамках Игры. Право собственности на неактивированные Данные и Команды не переходит к Пользователю.'
    },
    {type: 'heading', text: '8. Порядок приобретения Прав на неактивированные Данные и Команды.'},
    {
      type: 'paragraph',
      text: '8.1. Оплата Прав на неактивированные Данные и Команды осуществляется через платежные системы, указанные на Сайте.'
    },
    {
      type: 'paragraph',
      text: '8.2. После получения подтверждения оплаты Администрация зачисляет Виртуальную валюту на Учетную запись Пользователя в разумный срок.'
    },
    {
      type: 'paragraph',
      text: '8.3. Все покупки Прав на неактивированные Данные и Команды являются окончательными и не подлежат возврату или обмену. Исключения могут быть предусмотрены только действующим законодательством РФ или правилами Сайта.'
    },
    {type: 'paragraph', text: '8.4. Совершая платеж, Пользователь подтверждает свое совершеннолетие (18+).'},
    {
      type: 'paragraph',
      text: '8.5. Пользователь признаёт, что любой платеж или покупка на Сайте или в Игре совершается в целях развлечения, а не инвестирования.'
    },
    {
      type: 'paragraph',
      text: '8.6. Сайт не является организатором азартных игр или лотерей. Деятельность Сайта не подпадает под действие Федерального закона от 29.12.2006 № 244-ФЗ «О государственном регулировании деятельности по организации и проведению азартных игр», так как:'
    },
    {type: 'listItem', text: 'Игровой процесс не основан на риске потери денежных средств (ставке).'},
    {
      type: 'listItem',
      text: 'Пользователь получает заранее определенные (пусть и случайные) Права на неактивированные Данные и Команды в рамках игровой механики, а не денежный выигрыш.'
    },
    {
      type: 'listItem',
      text: 'Права на неактивированные Данные и Команды не имеют реальной денежной стоимости и не могут быть обменены на денежные средства.'
    },
    {type: 'heading', text: '9. Файлы cookie и похожие технологии'},
    {
      type: 'paragraph',
      text: '9.1. Сайт использует файлы cookie и подобные технологии для обеспечения работоспособности, улучшения пользовательского опыта и сбора статистики.'
    },
    {
      type: 'paragraph',
      text: '9.2. Пользователь может отказаться от использования файлов cookie в настройках своего браузера, однако это может привести к некорректной работе некоторых функций Сайта.'
    },
    {
      type: 'paragraph',
      text: '9.3. Третьи стороны (например, платёжные системы, аналитические сервисы) также могут использовать свои файлы cookie. Администрация не контролирует их.'
    },
    {
      type: 'paragraph',
      text: '9.4. На Сайте установлен счётчик Top.Mail.Ru (пиксель VK Рекламы, ООО «ВК»), который собирает сведения о посещениях и действиях на Сайте для оценки эффективности рекламных кампаний, показа рекламы и формирования рекламных аудиторий. Обработка таких данных регулируется политикой конфиденциальности VK: https://vk.com/privacy'
    },
    {
      type: 'paragraph',
      text: '9.5. На Сайте установлен счётчик Яндекс Метрики (ООО «ЯНДЕКС»), который собирает сведения о посещениях и действиях на Сайте для оценки эффективности рекламных кампаний, улучшения Сайта, показа рекламы и формирования рекламных аудиторий (ретаргетинг). В составе Яндекс Метрики включена технология «Вебвизор»: она записывает действия Пользователя в интерфейсе Сайта — перемещения указателя, прокрутку, нажатия, переходы между экранами, а также содержимое отображаемых страниц, — чтобы Администрация могла воспроизвести сеанс и увидеть, где Пользователи испытывают затруднения. Обработка таких данных регулируется Условиями использования сервиса Яндекс Метрика: https://yandex.ru/legal/metrica_termsofuse/ и Политикой конфиденциальности Яндекса: https://yandex.ru/legal/confidential/'
    },
    {
      type: 'paragraph',
      text: '9.6. Данные, собираемые счётчиками, указанными в пунктах 9.4 и 9.5, передаются их владельцам и обрабатываются на их стороне на условиях их собственных документов. Администрация не передаёт указанным сервисам адрес электронной почты, платёжные данные и иные сведения, позволяющие напрямую установить личность Пользователя; вместе с тем Сайт передаёт им внутренний игровой идентификатор Пользователя, позволяющий сопоставлять посещения с разных устройств, поэтому собираемые сведения не являются полностью обезличенными. Счётчики начинают работу с момента открытия Сайта, в том числе до входа в учётную запись.'
    },
    {type: 'heading', text: '10. Изменение Политики конфиденциальности'},
    {
      type: 'paragraph',
      text: '10.1 Администрация оставляет за собой право вносить изменения в настоящую Политику. Все изменения публикуются на этой странице с указанием даты последнего обновления. Пользователь обязуется самостоятельно отслеживать обновления. Продолжение использования Сайта означает принятие новой версии Политики.'
    },
    {type: 'heading', text: '11. Контактная информация'},
    {
      type: 'paragraph',
      text: 'По всем вопросам, связанным с обработкой персональных данных, Пользователь может обратиться:'
    },
    {type: 'paragraph', text: 'Администрация: ИП Баценков Я.С. ИНН 671406364925'},
    {type: 'paragraph', text: 'Электронная почта: strategikon.game@yandex.ru'},
  ],
};
